export default "__VITE_PUBLIC_ASSET__b328e033__"